import { formatMoney } from '../../lib/utils'
import { escopoBloqueado } from '../../lib/paresImportacao'
import type { EscopoExclusao, EscopoQtdValor, EscoposExclusao } from '../../types'

const rotuloQtd = (qtd: number, valor: number) => `${qtd} ${qtd === 1 ? 'parcela' : 'parcelas'}, ${formatMoney(valor)}`

/** Escolha do que apagar de uma compra parcelada: só esta parcela, esta e as seguintes, ou a compra inteira (com quantidade e valor de cada). */
export function EscolhaEscopo({ nome, escopos, valor, onChange }: {
  nome: string
  escopos: EscoposExclusao
  valor: EscopoExclusao
  onChange: (e: EscopoExclusao) => void
}) {
  const opcoes: { id: EscopoExclusao; rotulo: string; dados: EscopoQtdValor | null }[] = [
    { id: 'Apenas', rotulo: 'Só esta parcela', dados: escopos.apenas },
    { id: 'EstaESeguintes', rotulo: 'Esta e as seguintes', dados: escopos.estaESeguintes },
    { id: 'Todas', rotulo: 'A compra inteira', dados: escopos.todas },
  ]
  return (
    <fieldset className="space-y-1 text-12">
      <legend className="mb-1 text-muted">O que apagar da compra parcelada</legend>
      {opcoes.map((o) => {
        const d = o.dados
        if (!d) return null
        const bloqueado = escopoBloqueado(d)
        return (
          <label key={o.id} className={`flex flex-wrap items-center gap-2 ${bloqueado ? 'text-muted' : 'text-white'}`}>
            <input type="radio" name={nome} checked={valor === o.id} disabled={bloqueado} onChange={() => onChange(o.id)} />
            <span>{o.rotulo}{o.id === 'Apenas' ? ' (padrão)' : ''}</span>
            <span className="text-muted">{rotuloQtd(d.qtd, d.valor)}</span>
            {bloqueado && <span className="text-warning">{d.temPluggy ? 'inclui parcela do banco (Pluggy)' : 'inclui parcela de fatura paga'}</span>}
          </label>
        )
      })}
    </fieldset>
  )
}
